import { render, staticRenderFns } from "./RecordingStep.vue?vue&type=template&id=ed335c80"
import script from "./RecordingStep.vue?vue&type=script&lang=js"
export * from "./RecordingStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports